import React from 'react';
import { FaCheckCircle } from 'react-icons/fa';

import './product.css';
import Header from '../../components/header/Header';
import doctor_with_stethascope from '../../assets/images/doctors/doctor_with_stethascope.png';
import Care_Img from '../../assets/images/icons/care_img.png'
import CommCard from '../../components/commCard/CommCard';
import Footer from '../../components/footer/Footer';
import mobile_yellow from '../../assets/images/devices/mobile_yellow.png';

// Video
import productVideo from "../../assets/video/product.mp4"



const Product = () => {
  return (
    <div>
      <Header h1="Product" p="Home" p1="Product"/>

      {/* PRODUCT VIDEO SECTION */}

      <section className="video_product">
        <div className="container video_content">
          <video src={productVideo} autoPlay={true} muted={true} loop={true} />
        </div>
      </section>


      {/* SERVICES SECTION */}

      <section className="provide_services">
        <div className="container services_container">
          <div className="services_left">
            <img src={doctor_with_stethascope} alt="doctor_with_stethascope" className='doc_img' />
          </div>
          <div className="services_right flex flex-col text-justify">
            <h2 className="text-3xl font-bold leading-10 w-11/12 mb-4">We Provide Essential Products For Your Health Care</h2>
            <p className="mt-4 text-base leading-7">We are working on the development of Tele-diagnostic devices that allow patients to receive remote consultations and diagnoses from nearby pharmacies and clinics. This significantly reduces the need for long-distance travel and improves access to quality care for rural and semi-urban populations. This will ensure that patients receive the treatments they need in a timely manner.</p>
            <div className="services_icon_text flex flex-row mt-4 space-x-4">
            <div className="services_icon flex flex-col space-y-6 mt-3.5">
              <FaCheckCircle />
              <FaCheckCircle />
              <FaCheckCircle />
            </div>
            <div className="services_right_text">
              <p className="leading-10 text-ls font-normal">24 Hours Emergency Assistance Call Us</p>
              <p className="leading-10 text-ls font-normal">We are committed to providing healthcare service</p>
              <p className="leading-10 text-ls font-normal">Really know the true needs and expectations of patients</p>
            </div>
          </div>
          </div>
        </div>
      </section>


      {/* CARE HEALTH SECTION */}

      <section className="careHealth">
        <div className="container care_container flex flex-col items-center">
          <h3 className="text-black text-3xl font-bold mb-4">We Care About Your Health</h3>
          <p className="text-base font-normal w-3/4 text-center mb-4 leading-7">We have introduced the principle of family medicine, which means that the family practitioner will handle the majority of medical requests, with a specialists involved only if necessary.</p>

          <div className="card_care_container flex flex-row space-x-8 mt-8">
            <div className="card card_care flex flex-col items-center space-y-4">
              <img src={Care_Img} alt="Care_Img" />
              <h3 className="text-2xl">Family Care</h3>
              <p className="text-sm leading-7 text-center">Through tele-consultation is an innovative way to provide family care services to patients remotely. It involves the use of technology to connect patients with their healthcare providers via video.</p>
            </div>
            <div className="card card_care flex flex-col items-center space-y-4">
              <img src={Care_Img} alt="Care_Img" />
              <h3 className="text-2xl">Urgent Care</h3>
              <p className="text-sm leading-7 text-center">Tele-consultation is an excellent option for providing urgent care services to patients who are unable to visit a healthcare provider in person.</p>
            </div>
            <div className="card card_care flex flex-col items-center space-y-4">
              <img src={Care_Img} alt="Care_Img" />
              <h3 className="text-2xl">Regular Care</h3>
              <p className="text-sm leading-7 text-center">Tele-consultation can also be used for regular care services, providing a convenient and effective option for patients to receive healthcare services from the comfort of their own home.</p>
            </div>
          </div>
        </div>
      </section>


      <CommCard dynamicImg={mobile_yellow} text="Operator" />

      <Footer />
    </div>
  )
}

export default Product;